const prepareNewArr = (arr, objKey) => {
  let newArr = [];
  for (const key in arr) {
    if (Object.hasOwnProperty.call(arr, key)) {
      const element = arr[key];
      newArr.push({
        id: element.id,
        name: element?.translations[0][objKey || "name"],
      });
    }
  }
  return newArr;
};

export default prepareNewArr;
